import { useRef, useState } from "react";
import { Loader2, Paperclip, X } from "lucide-react";
import { api, errMsg, fileUrl } from "@/lib/api";
import { toast } from "sonner";

/** Uploads any document type and stores it as "filename|file_id". */
export const FileRefInput = ({ value, onChange, label = "Attach", testId }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [name, id] = String(value || "").split("|");

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/personnel/files", fd,
        { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.ref);
      toast.success(`${data.filename} attached`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  if (id) {
    return (
      <div className="flex items-center gap-1.5 text-xs" data-testid={`${testId}-attached`}>
        <a href={fileUrl(id)} target="_blank" rel="noreferrer"
          className="text-[#002FA7] hover:underline truncate max-w-[150px]">{name}</a>
        <button type="button" onClick={() => onChange("")} data-testid={`${testId}-clear`}
          className="text-[#6B7280] hover:text-[#C92A2A]"><X className="h-3.5 w-3.5" /></button>
      </div>
    );
  }

  return (
    <>
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={testId}
        className="inline-flex items-center h-9 px-2.5 rounded-md border border-[#E5E7EB] bg-white text-xs hover:border-[#002FA7]">
        {busy ? <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" /> : <Paperclip className="h-3.5 w-3.5 mr-1 text-[#002FA7]" />}
        {label}
      </button>
      <input ref={ref} type="file" className="hidden" data-testid={`${testId}-input`}
        onChange={(e) => { upload(e.target.files?.[0]); e.target.value = ""; }} />
    </>
  );
};
